module.exports = __webpack_public_path__ + "img/img04.56b3ec52.png";